export default __webpack_public_path__ + "static/media/location.2268f2b7.svg";